<div style="text-align: center;">
  <iframe id="video-link" frameborder="0" [src]="getUrl()" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>


